const initialState = {
  isLoading: false,
  user: {},
  errors: null,
  isAuthenticated: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "User_req":
      return {
        ...state,
        isLoading: true,
      };
    case "User_success":
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        user: action.payload,
      };
    case "User_failure":
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        errors: action.payload,
      };

    default:
      return state;
  }
};

const forgotState = {
  isLoading: false,
  user: {},
  errors: null,
};
const forgotreducer = (state = forgotState, action) => {
  switch (action.type) {
    case "Password_req":
      return {
        ...state,
        isLoading: true,
      };
    case "Password_success":
      return {
        ...state,
        isLoading: false,
        user: action.payload,
      };
    case "Password_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };

    default:
      return state;
  }
};
export { authReducer, forgotreducer };
